module.exports = __webpack_public_path__ + "img/info.cd2dd1f5.png";